import { EventPanelTab } from './event-panel-tabs-config';
import { FullModeActiveTab } from './full-mode-active-tab';
import { InlineModeActiveTab } from './inline-mode-active-tab';
import { TabMode } from './types';

export function ActiveTab({ activeTab, mode }: { activeTab?: EventPanelTab; mode: TabMode }) {
    if (!activeTab) {
        return <></>;
    }
    return mode === 'FULL' ? (
        <FullModeActiveTab activeTab={activeTab} />
    ) : (
        <InlineModeActiveTab activeTab={activeTab} />
    );
}
